import { createSlice } from '@reduxjs/toolkit'
import name from './name'
import playlist from '../playlist'

const initialState = {
  progressData: [],
  playlistIds: [],
  loadingIndicator: false
}

export const content = createSlice({
  name,
  initialState,
  reducers: {
    setProgress: (state, { payload }) => {
      state.playlistIds = []
      state.progressData = payload
    },
    togglePlaylistContentRead: (state, { payload }) => {
      state.loadingIndicator = false
      state.playlistIds = [payload.playlistId]
    },
    setLoadingIndicator: (state, { payload }) => {
      state.loadingIndicator = payload.visible
    },
    reset: state => initialState
  },
  /**
   * The playlist landing used to collect every returned playlist's pk here.
   * Nothing on that page consumes progress — it renders no
   * PlaylistProgressProvider — so the ids sat in state until the next detail
   * page mounted and asked for progress on all of them. The landing returns up
   * to 500 playlists, which is past the 100-key ceiling on DynamoDB's
   * BatchGetItem, and the request came back 503.
   *
   * A playlist is the only thing that needs progress, so only opening one asks
   * for it.
   */
  extraReducers: (builder) => {
    builder
      .addCase(playlist.actions.setDetail, (state, { payload: { playlist: { pk } } }) => {
        if (!pk) return
        state.playlistIds = [pk]
      })
  }
})

export const { setProgress, togglePlaylistContentRead, setLoadingIndicator } = content.actions

export default content.reducer
